<script setup lang="ts">
const props = defineProps<{
  on: boolean
  nr: string | None
  done: boolean
  label: stringI18n | None
  loading: boolean | None
  editMsg: stringI18n | None
  mobile: boolean
}>()
</script>

<template>
  <div v-if="label || nr" :class="[$style.h1, { done: done || on }]">
    <IconDone v-if="nr?.length" :completed="!!done" :blue="on" :black="!on && done" :size="mobile ? '24' : '28'" />
    <span v-if="nr?.length" :class="$style.nr">{{ nr }}.</span>
    <span v-if="label" class="_upper" :class="$style.la">{{ label }}</span>
    <UiMsg v-if="editMsg && on" :txt="editMsg" blue class="_ml1" />
    <div class="_relative _ctr _h28 _w50"><UiLoading v-if="loading" /></div>
  </div>
</template>

<style module>
.h1 {
  composes: global(_row);
  composes: global(_ctrY);
  --color: var(--black-4);
}
.h1:global(.done) {
  --color: var(--black);
}
.nr {
  composes: global(d_fw-xl);
  composes: global(m_fw-xxl);
  composes: global(_mono);
  composes: global(_ml14);
  composes: global(_mr1);
  composes: global(_lh1);
  color: var(--color);
}
.la {
  color: var(--color);
}
:global(.d) .nr {
  font-size: 14px;
}
:global(.m) .nr {
  font-size: 17px;
  margin-top: 2px;
}
</style>
